module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "epigraph"
    }
  }, [_vm._v("Tempt not the stars, young man; thou canst not play With the severity of fate. . . . In thy aspect I note A consequence of danger.")])]), _c('a', {
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "att"
  }, [_vm._v("—from "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Broken Heart")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0